export enum BurialRoutes {
    ROOT = "/mis-seguros/pga/sepelio",
    ROUTE_INSURANCE_POLICY_DETAIL = "/mis-seguros/pga/sepelio/:productCode/detalle-poliza/:systemCode/:policyId",
    ROUTE_INSURANCE_COVERAGES = "/mis-seguros/pga/sepelio/:productCode/coberturas/:systemCode/:policyId",
    ROUTE_INSURANCE_COVERAGE = "/mis-seguros/pga/sepelio/:productCode/coberturas/:systemCode/:policyId/cobertura/:coverageId",
    ROUTE_INSURANCE_PAYMENTS = "/v1/#/pga/sepelio/:productCode/mis-pagos/:systemCode/:policyId",
}
